<template>
    <div>
        <div class="demographics-content" style="margin-bottom:100px">
            <div class="table-paragraphics">
                <div class="para" v-if="paragraphics" v-html="paragraphics"></div>
                <div class="table-scroll">
                    <table class="table">
                        <thead>
                            <tr>
                                <th v-for="(header,index) in data.tableHeaders" :key="index"><b>{{header}}</b></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="data.tableValues && data.tableValues.length">
                                <tr v-for="(value,index) in data.tableValues" :key="index">
                                    <td v-for="(key,index) in getKeys" :key="index">
                                        {{value[key]}}
                                    </td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td> No data Available</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card" v-if="data.chartValues && data.chartValues.length">
                <div class="chart-name text-center"><b>{{data.chartName}}</b></div>
                <mvtChart :data="getChartData"></mvtChart>
            </div>
        </div>
    </div>
</template>

<script src="./markettrendsoverview.js"></script>

<style lang="scss">
@use "./markettrendsoverview.scss" as *;
</style>